import { action, thunk, computed } from 'easy-peasy';

export default {
	loading: false,
	setLoading: action((state, payload) => {
		state.loading = payload;
	}),
	items: [],
	total: computed(state => state.items.reduce((ac, cv) => ac + cv.value, 0)),
	save: action((state, payload) => {
		state.items = payload.library;
	}),
	reset: action(state => {
		state.items = [];
	}),
	load: thunk((actions, payload, { getStoreState, injections, getStoreActions }) => {
		const { services } = injections;
		actions.setLoading(true);
		services.catalog
			.opacCheck(payload)
			.then(data => actions.save(data))
			.catch(e => {
				getStoreActions().error('Errore nel recupero dei dati relativi ad OPAC Check');
			})
			.finally(_ => {
				actions.setLoading(false);
			});
	})
};
